import { Layout } from "pages/ui/page";
import { useUserPreferencesListQuery } from "shared/api/use-user-preferences-list-query";

import { Content } from "./content";

export const Preferences = () => {
  const preferencesQuery = useUserPreferencesListQuery();
  const knowledges = preferencesQuery.data?.permanent_knowledge ?? [];
  const language = preferencesQuery.data?.language;
  const timezone = preferencesQuery.data?.timezone;

  if (preferencesQuery.isPending) return <Layout isLoading />;
  if (preferencesQuery.isError) return <div>Error...</div>;

  return (
    <Content knowledges={knowledges} language={language} timezone={timezone} />
  );
};
